/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "coa/models.proto" (package "rd.coa", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Money } from "../proto/money/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * Account represents a company-customizable general ledger (GL) account that can be created and
 * modified by users. These accounts form the company's chart of accounts and can be mapped from
 * internal system accounts.
 *
 * @generated from protobuf message rd.coa.Account
 */
export interface Account {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: int32 number = 5
     */
    number: number;
    /**
     * @generated from protobuf field: rd.coa.Account.Type type = 6
     */
    type: Account_Type;
    /**
     * @generated from protobuf field: string name = 7
     */
    name: string;
    /**
     * @generated from protobuf field: rd.user.User created_by = 8
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 9
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.coa.Account.StartingBalance starting_balance = 11
     */
    startingBalance?: Account_StartingBalance;
    /**
     * @generated from protobuf field: bool is_active = 12
     */
    isActive: boolean;
}
/**
 * @generated from protobuf message rd.coa.Account.StartingBalance
 */
export interface Account_StartingBalance {
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 1
     */
    amount?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date = 2
     */
    date?: Timestamp;
}
/**
 * @generated from protobuf enum rd.coa.Account.Type
 */
export enum Account_Type {
    /**
     * @generated from protobuf enum value: Undefined = 0;
     */
    Undefined = 0,
    /**
     * @generated from protobuf enum value: Asset = 1;
     */
    Asset = 1,
    /**
     * @generated from protobuf enum value: Liability = 2;
     */
    Liability = 2,
    /**
     * @generated from protobuf enum value: Income = 3;
     */
    Income = 3,
    /**
     * @generated from protobuf enum value: Expense = 4;
     */
    Expense = 4,
    /**
     * @generated from protobuf enum value: Equity = 5;
     */
    Equity = 5,
    /**
     * @generated from protobuf enum value: COGS = 6;
     */
    COGS = 6
}
/**
 * @generated from protobuf message rd.coa.AccountLog
 */
export interface AccountLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.coa.Account account = 4
     */
    account?: Account;
    /**
     * @generated from protobuf field: rd.user.User created_by = 5
     */
    createdBy?: User;
}
/**
 * Mapping represents a mapping from a location, optional department, and internal account to a
 * company's account. This allows companies to customize how transactions are recorded in their
 * books while maintaining consistent internal accounting.
 * NOTE: At most one of department_id, tender_method_id, or additional_fee_id_string should be
 * set on any given mapping row.
 *
 * @generated from protobuf message rd.coa.Mapping
 */
export interface Mapping {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 5
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID department_id = 6
     */
    departmentId?: UUID;
    /**
     * @generated from protobuf field: rd.coa.InternalAccount internal_account = 7
     */
    internalAccount: InternalAccount;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID account_id = 8
     */
    accountId?: UUID;
    /**
     * @generated from protobuf field: bool should_be_separate_row = 9
     */
    shouldBeSeparateRow: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tender_method_id = 10
     */
    tenderMethodId?: UUID;
    /**
     * @generated from protobuf field: string additional_fee_id_string = 11
     */
    additionalFeeIdString: string;
}
/**
 * InternalAccount represents a system-managed general ledger (GL) account that cannot be modified
 * by users. These accounts serve as a bridge between our internal accounting operations and the
 * company's customizable chart of accounts. They ensure consistent accounting treatment across all
 * companies while allowing companies to map these system accounts to their own preferred account
 * structure.
 *
 * @generated from protobuf enum rd.coa.InternalAccount
 */
export enum InternalAccount {
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_CASH_DRAWER = 1;
     */
    ASSET_CASH_DRAWER = 1,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_CASH_RUNDOO_BANKING = 2;
     */
    ASSET_CASH_RUNDOO_BANKING = 2,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_CASH_EXTERNAL_BANK = 3;
     */
    ASSET_CASH_EXTERNAL_BANK = 3,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_ACCOUNTS_RECEIVABLE = 4;
     */
    ASSET_ACCOUNTS_RECEIVABLE = 4,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_INTERCOMPANY_RECEIVABLES = 5;
     */
    ASSET_INTERCOMPANY_RECEIVABLES = 5,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_PENDING_CARD_DEPOSITS = 6;
     */
    ASSET_PENDING_CARD_DEPOSITS = 6,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_PENDING_CASH_DEPOSITS = 7;
     */
    ASSET_PENDING_CASH_DEPOSITS = 7,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_PENDING_CHECK_DEPOSITS = 8;
     */
    ASSET_PENDING_CHECK_DEPOSITS = 8,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_INVENTORY = 9;
     */
    ASSET_INVENTORY = 9,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_COMMITTED_INVENTORY = 10;
     */
    ASSET_COMMITTED_INVENTORY = 10,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_ON_ORDER_INVENTORY = 11;
     */
    ASSET_ON_ORDER_INVENTORY = 11,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_NON_STOCK_INVENTORY = 12;
     */
    ASSET_NON_STOCK_INVENTORY = 12,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_COMMITTED_NON_STOCK_INVENTORY = 13;
     */
    ASSET_COMMITTED_NON_STOCK_INVENTORY = 13,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_ON_ORDER_NON_STOCK_INVENTORY = 14;
     */
    ASSET_ON_ORDER_NON_STOCK_INVENTORY = 14,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_LIABILITY_ACCOUNTS_PAYABLE = 15;
     */
    LIABILITY_ACCOUNTS_PAYABLE = 15,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_LIABILITY_SALES_TAX_PAYABLE = 16;
     */
    LIABILITY_SALES_TAX_PAYABLE = 16,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_LIABILITY_UNCATEGORIZED = 17;
     */
    LIABILITY_UNCATEGORIZED = 17,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_LIABILITY_PENDING_ORDERS = 18;
     */
    LIABILITY_PENDING_ORDERS = 18,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EQUITY_RETAINED_EARNINGS = 19;
     */
    EQUITY_RETAINED_EARNINGS = 19,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_INCOME_SALES = 20;
     */
    INCOME_SALES = 20,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_INCOME_INTEREST = 21;
     */
    INCOME_INTEREST = 21,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_INCOME_CARD_SURCHARGE = 22;
     */
    INCOME_CARD_SURCHARGE = 22,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_COGS_INVENTORY_COGS = 23;
     */
    COGS_INVENTORY_COGS = 23,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_COGS_INVENTORY_ADJUSTMENT = 24;
     */
    COGS_INVENTORY_ADJUSTMENT = 24,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_COGS_NON_STOCK_INVENTORY_COGS = 25;
     */
    COGS_NON_STOCK_INVENTORY_COGS = 25,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_COGS_NON_STOCK_INVENTORY_ADJUSTMENT = 26;
     */
    COGS_NON_STOCK_INVENTORY_ADJUSTMENT = 26,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_PETTY_CASH = 27;
     */
    EXPENSE_PETTY_CASH = 27,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_OVER_SHORT = 28;
     */
    EXPENSE_OVER_SHORT = 28,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_INVENTORY_TRANSFER = 29;
     */
    EXPENSE_INVENTORY_TRANSFER = 29,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_NON_STOCK_INVENTORY_TRANSFER = 30;
     */
    EXPENSE_NON_STOCK_INVENTORY_TRANSFER = 30,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_BAD_DEBT = 31;
     */
    EXPENSE_BAD_DEBT = 31,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_CREDIT_CARD_FEES = 32;
     */
    EXPENSE_CREDIT_CARD_FEES = 32,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_LIABILITY_CUSTOMER_DEPOSITS = 33;
     */
    LIABILITY_CUSTOMER_DEPOSITS = 33,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_INCOME_FORFEITED_DEPOSITS = 34;
     */
    INCOME_FORFEITED_DEPOSITS = 34,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_EARLY_PAYMENT_DISCOUNT = 35;
     */
    EXPENSE_EARLY_PAYMENT_DISCOUNT = 35,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_INCOME_ADDITIONAL_FEES = 36;
     */
    INCOME_ADDITIONAL_FEES = 36,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_ADDITIONAL_FEES = 37;
     */
    EXPENSE_ADDITIONAL_FEES = 37,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_CUSTOM_TENDER = 38;
     */
    ASSET_CUSTOM_TENDER = 38,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_INCOME_ACH_SURCHARGE = 39;
     */
    INCOME_ACH_SURCHARGE = 39,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_ASSET_PENDING_ACH_DEPOSITS = 40;
     */
    ASSET_PENDING_ACH_DEPOSITS = 40,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_EXPENSE_ACH_FEES = 41;
     */
    EXPENSE_ACH_FEES = 41,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_LIABILITY_GIFT_CARD_DEFFERED_REVENUE = 42;
     */
    LIABILITY_GIFT_CARD_DEFFERED_REVENUE = 42,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_INCOME_GIFT_CARD_REVENUE = 43;
     */
    INCOME_GIFT_CARD_REVENUE = 43,
    /**
     * @generated from protobuf enum value: INTERNAL_ACCOUNT_INCOME_DISCOUNT = 44;
     */
    INCOME_DISCOUNT = 44
}
// @generated message type with reflection information, may provide speed optimized methods
class Account$Type extends MessageType<Account> {
    constructor() {
        super("rd.coa.Account", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "type", kind: "enum", T: () => ["rd.coa.Account.Type", Account_Type] },
            { no: 7, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_by", kind: "message", T: () => User },
            { no: 9, name: "updated_by", kind: "message", T: () => User },
            { no: 11, name: "starting_balance", kind: "message", T: () => Account_StartingBalance },
            { no: 12, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Account>): Account {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.number = 0;
        message.type = 0;
        message.name = "";
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial<Account>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account): Account {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* int32 number */ 5:
                    message.number = reader.int32();
                    break;
                case /* rd.coa.Account.Type type */ 6:
                    message.type = reader.int32();
                    break;
                case /* string name */ 7:
                    message.name = reader.string();
                    break;
                case /* rd.user.User created_by */ 8:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 9:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.coa.Account.StartingBalance starting_balance */ 11:
                    message.startingBalance = Account_StartingBalance.internalBinaryRead(reader, reader.uint32(), options, message.startingBalance);
                    break;
                case /* bool is_active */ 12:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 number = 5; */
        if (message.number !== 0)
            writer.tag(5, WireType.Varint).int32(message.number);
        /* rd.coa.Account.Type type = 6; */
        if (message.type !== 0)
            writer.tag(6, WireType.Varint).int32(message.type);
        /* string name = 7; */
        if (message.name !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.name);
        /* rd.user.User created_by = 8; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 9; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.coa.Account.StartingBalance starting_balance = 11; */
        if (message.startingBalance)
            Account_StartingBalance.internalBinaryWrite(message.startingBalance, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 12; */
        if (message.isActive !== false)
            writer.tag(12, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.coa.Account
 */
export const Account = new Account$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account_StartingBalance$Type extends MessageType<Account_StartingBalance> {
    constructor() {
        super("rd.coa.Account.StartingBalance", [
            { no: 1, name: "amount", kind: "message", T: () => Money },
            { no: 2, name: "date", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<Account_StartingBalance>): Account_StartingBalance {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Account_StartingBalance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account_StartingBalance): Account_StartingBalance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money amount */ 1:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* google.protobuf.Timestamp date */ 2:
                    message.date = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.date);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account_StartingBalance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money amount = 1; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp date = 2; */
        if (message.date)
            Timestamp.internalBinaryWrite(message.date, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.coa.Account.StartingBalance
 */
export const Account_StartingBalance = new Account_StartingBalance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountLog$Type extends MessageType<AccountLog> {
    constructor() {
        super("rd.coa.AccountLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "account", kind: "message", T: () => Account },
            { no: 5, name: "created_by", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<AccountLog>): AccountLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccountLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountLog): AccountLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.coa.Account account */ 4:
                    message.account = Account.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* rd.user.User created_by */ 5:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.coa.Account account = 4; */
        if (message.account)
            Account.internalBinaryWrite(message.account, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 5; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.coa.AccountLog
 */
export const AccountLog = new AccountLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Mapping$Type extends MessageType<Mapping> {
    constructor() {
        super("rd.coa.Mapping", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "location_id", kind: "message", T: () => UUID },
            { no: 6, name: "department_id", kind: "message", T: () => UUID },
            { no: 7, name: "internal_account", kind: "enum", T: () => ["rd.coa.InternalAccount", InternalAccount, "INTERNAL_ACCOUNT_"] },
            { no: 8, name: "account_id", kind: "message", T: () => UUID },
            { no: 9, name: "should_be_separate_row", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "tender_method_id", kind: "message", T: () => UUID },
            { no: 11, name: "additional_fee_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Mapping>): Mapping {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.internalAccount = 0;
        message.shouldBeSeparateRow = false;
        message.additionalFeeIdString = "";
        if (value !== undefined)
            reflectionMergePartial<Mapping>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Mapping): Mapping {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 5:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID department_id */ 6:
                    message.departmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.departmentId);
                    break;
                case /* rd.coa.InternalAccount internal_account */ 7:
                    message.internalAccount = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID account_id */ 8:
                    message.accountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* bool should_be_separate_row */ 9:
                    message.shouldBeSeparateRow = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID tender_method_id */ 10:
                    message.tenderMethodId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.tenderMethodId);
                    break;
                case /* string additional_fee_id_string */ 11:
                    message.additionalFeeIdString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Mapping, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 5; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID department_id = 6; */
        if (message.departmentId)
            UUID.internalBinaryWrite(message.departmentId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.coa.InternalAccount internal_account = 7; */
        if (message.internalAccount !== 0)
            writer.tag(7, WireType.Varint).int32(message.internalAccount);
        /* rd.proto.uuid.UUID account_id = 8; */
        if (message.accountId)
            UUID.internalBinaryWrite(message.accountId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool should_be_separate_row = 9; */
        if (message.shouldBeSeparateRow !== false)
            writer.tag(9, WireType.Varint).bool(message.shouldBeSeparateRow);
        /* rd.proto.uuid.UUID tender_method_id = 10; */
        if (message.tenderMethodId)
            UUID.internalBinaryWrite(message.tenderMethodId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string additional_fee_id_string = 11; */
        if (message.additionalFeeIdString !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.additionalFeeIdString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.coa.Mapping
 */
export const Mapping = new Mapping$Type();
